import { render, staticRenderFns } from "./step_3.vue?vue&type=template&id=885604d6&scoped=true&"
import script from "./step_3.vue?vue&type=script&lang=js&"
export * from "./step_3.vue?vue&type=script&lang=js&"
import style0 from "./step_3.vue?vue&type=style&index=0&id=885604d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885604d6",
  null
  
)

export default component.exports